import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";

// Lazy-loaded pages (code-splitting)
const Alpha = lazy(() => import("./pages/Alpha.tsx"));
const Trafego = lazy(() => import("./pages/Trafego.tsx"));
const Lancamentos = lazy(() => import("./pages/Lancamentos.tsx"));
const Marcas = lazy(() => import("./pages/Marcas.tsx"));
const Grafica = lazy(() => import("./pages/Grafica.tsx"));
const Funis = lazy(() => import("./pages/Funis.tsx"));
const Estrategia = lazy(() => import("./pages/Estrategia.tsx"));
const DirectResponse = lazy(() => import("./pages/DirectResponse.tsx"));
const AutomacoesIA = lazy(() => import("./pages/AutomacoesIA.tsx"));
const Ecommerce = lazy(() => import("./pages/Ecommerce.tsx"));
const Sites = lazy(() => import("./pages/Sites.tsx"));
const Mentorias = lazy(() => import("./pages/Mentorias.tsx"));
const SobreNos = lazy(() => import("./pages/SobreNos.tsx"));
const Politica = lazy(() => import("./pages/Politica.tsx"));
const Termos = lazy(() => import("./pages/Termos.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const LinksRedirect = lazy(() => import("./pages/LinksRedirect.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/alpha" element={<Alpha />} />
              <Route path="/trafego" element={<Trafego />} />
              <Route path="/lancamentos" element={<Lancamentos />} />
              <Route path="/marcas" element={<Marcas />} />
              <Route path="/grafica" element={<Grafica />} />
              <Route path="/funis" element={<Funis />} />
              <Route path="/estrategia" element={<Estrategia />} />
              <Route path="/direct-response" element={<DirectResponse />} />
              <Route path="/ai" element={<AutomacoesIA />} />
              <Route path="/ecommerce" element={<Ecommerce />} />
              <Route path="/sites" element={<Sites />} />
              <Route path="/mentorias" element={<Mentorias />} />
              <Route path="/sobrenos" element={<SobreNos />} />
              <Route path="/politica" element={<Politica />} />
              <Route path="/termos" element={<Termos />} />
              <Route path="/links" element={<LinksRedirect />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
